import { render, staticRenderFns } from "./AiDisclosureField.vue?vue&type=template&id=9c25eb84&scoped=true&lang=pug&"
import script from "./AiDisclosureField.vue?vue&type=script&lang=js&"
export * from "./AiDisclosureField.vue?vue&type=script&lang=js&"
import style0 from "./AiDisclosureField.vue?vue&type=style&index=0&id=9c25eb84&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c25eb84",
  null
  
)

/* custom blocks */
import block0 from "./AiDisclosureField.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports